export default __webpack_public_path__ + "static/media/gb-sct.0e1b783f.svg";